import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import * as Sentry from '@sentry/react';

import { uuidv4 } from '@looko-corp/acloset-react-kit/src/utils/uuid';

/**
 * Sentry 를 초기화 합니다.
 */
export const initSentry = () => {
  Sentry.init({
    enabled: import.meta.env.PROD,

    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
      }),
      // XXX: 성능 이슈 있음
      // new Sentry.Replay(),
    ],

    // replaysSessionSampleRate: import.meta.env.DEV ? 0.1 : 0.3,
    replaysOnErrorSampleRate: 1.0,

    tracesSampleRate: 1.0,
    maxBreadcrumbs: 200,

    environment: import.meta.env.MODE,
    release: _APP_VERSION,

    beforeBreadcrumb: (breadcrumb, hint) => {
      // XHR 네트워크 후킹.
      if (breadcrumb.category === 'xhr') {
        return {
          ...breadcrumb,
          data: {
            status: hint?.xhr?.status,
            method: hint?.xhr?.__sentry_xhr_v2__?.method,
            requestID: hint?.xhr?.__sentry_xhr_v2__?.request_headers?.request_id,
            'x-amz-cf-id': hint?.xhr?.responseHeaders?.['x-amz-cf-id'],
            requestBody: hint?.xhr?.__sentry_xhr_v2__.body.substring(0, 40),
            response: (hint?.xhr?.response != null ? hint.xhr?.response : hint?.xhr?._response)?.substring(0, 40),
            responseUrl: hint?.xhr?.responseURL,
          },
        };
      }
      return breadcrumb;
    },
  });

  Sentry.setTags({
    buildTimeMs: _BUILD_TIME_MS,
    devMode: import.meta.env.DEV,
    hardwareConcurrency: window.navigator.hardwareConcurrency,
    deviceMemory:
      'deviceMemory' in window.navigator && typeof window.navigator.deviceMemory === 'number'
        ? window.navigator.deviceMemory
        : 0,
  });

  let sessionID = sessionStorage.getItem('looko:session:id');
  if (!sessionID) {
    sessionID = uuidv4();
    sessionStorage.setItem('looko:session:id', sessionID);
  }

  Sentry.setContext('browser', {
    sessionID: sessionID,
  });
};
